module.exports = __webpack_public_path__ + "img/go.218afe8c.svg";